import { ObservableArray, View } from "binder"
import { singleUsage, UserSessionLogsViewModel } from "./userSessionLogs-viewModel"
import { ServerSideDataLoader } from "uicomponents";

export class UserSessionLogsView extends View<UserSessionLogsViewModel>{
    GetViewUniqueId(): string {
        return "V-2817B770-43C6-4A6C-AB89-B45041E4337D"
    }
    loadHtml(): string {
        let element = require('./userSessionLogs.html').default;
        let style = require('./userSessionLogs.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<singleUsage>) { this._items = v; } public get items(): ObservableArray<singleUsage> { return this._items;} private _items: ObservableArray<singleUsage>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;

}
